module.exports = __webpack_public_path__ + "img/process-icon-1.7d12682a.svg";